import * as actionTypes from 'actions/actionTypes'

const initialState = {
  user: {
    idBusiness: 0,
    userEmail: '',
    firstName: '',
    lastName: '',
    mobile: '',
    phone: '',
    subscribeEmailCampaign: false
  },
  companies: [],
  goToSignup: false,
  signUpFinished: false,
  error: false,
  errorMessage: '',
  preLogin: false,
  needToTryAutomaticLogin: true,
  isLoading: false,
  referalFriendCode: null,
  linkCode: null,
  email: ''
}

const signUpReducer = (state = initialState, action) => {
  let userUpdate = null
  switch (action.type) {
    case actionTypes.START_SIGNUP:
      let userEmail = action.email
      userUpdate = {
        ...state.user,
        userEmail
      }
      return {
        ...state,
        user: userUpdate,
        goToSignup: true,
      }
    case actionTypes.USER_LOGGING_IN:
      return {
        ...state,
        isLoading: true,
      }
    case actionTypes.USER_LOGGING_OUT:
      return {
        ...state,
        isLoading: false,
        needToTryAutomaticLogin: false,
      }
    case actionTypes.REQUEST_FAILED:
      return {
        ...state,
        error: true,
        errorMessage: action.errorMessage
      }

    case actionTypes.PRE_LOGIN:
      return {
        ...state,
        preLogin: true,
        email: action.email
      }
    case actionTypes.CLOSE_MODAL_ERROR:
      return {
        ...state,
        error: false
      }
    case actionTypes.SET_COMPANIES_TO_USER:
      return {
        ...state,
        companies: action.companies
      }
    case actionTypes.SELECT_COMPANY:
      let idBusiness = action.idBusiness
      userUpdate = {
        ...state.user,
        idBusiness
      }
      return {
        ...state,
        user: userUpdate
      }
    case actionTypes.REQUEST_SIGNUP_SUCCESSFUL:
      userUpdate = {
        ...action.user
      }
      return {
        ...state,
        signUpFinished: action.signUpFinished,
        user: userUpdate
      }
    case actionTypes.CLOSE_SIGNUP:
      return {
        ...state,
        goToSignup: false,
        isDuplicated: false
      }
    case actionTypes.CLOSE_EMAIL_CONFIRMATION:
      return {
        ...state,
        user: {},
        companies: [],
        goToSignup: false,
        signUpFinished: false,
        isDuplicated: false,
        referalFriendCode: null,
        linkCode: null
      }
    case actionTypes.REQUEST_SUCCESS_LOGIN:
      return {
        ...state,
        preLogin: false
      }
    case actionTypes.SIGNUP_SET_REFERAL_FRIEND_CODE:
      return {
        ...state,
        referalFriendCode: action.referalFriendCode
      }
    case actionTypes.SIGNUP_SET_LINK_CODE:
      return {
        ...state,
        linkCode: action.code
      }

    default:
      return state
  }
}

export default signUpReducer



// WEBPACK FOOTER //
// ./src/store/reducers/signUpReducer.js